/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

// Import Routes

import { Route as rootRoute } from './routes/__root'
import { Route as InvitationImport } from './routes/invitation'
import { Route as PublicImport } from './routes/_public'
import { Route as AuthenticatedImport } from './routes/_authenticated'
import { Route as IndexImport } from './routes/index'
import { Route as PublicVerifyImport } from './routes/_public/verify'
import { Route as PublicSignupImport } from './routes/_public/signup'
import { Route as PublicResetPasswordImport } from './routes/_public/reset-password'
import { Route as PublicLoginImport } from './routes/_public/login'
import { Route as AuthenticatedLogoutImport } from './routes/_authenticated/logout'
import { Route as AuthenticatedScheduleIndexImport } from './routes/_authenticated/schedule/index'
import { Route as AuthenticatedMemberIndexImport } from './routes/_authenticated/member/index'
import { Route as AuthenticatedMeIndexImport } from './routes/_authenticated/me/index'
import { Route as AuthenticatedDashboardIndexImport } from './routes/_authenticated/dashboard/index'
import { Route as PublicOrganizationNewImport } from './routes/_public/organization/new'
import { Route as PublicOrganizationJoinImport } from './routes/_public/organization/join'
import { Route as PublicAuthGoogleImport } from './routes/_public/auth.google'
import { Route as AuthenticatedUserEditImport } from './routes/_authenticated/user/edit'
import { Route as AuthenticatedScheduleCreateImport } from './routes/_authenticated/schedule/create'
import { Route as AuthenticatedScheduleScheduleIdImport } from './routes/_authenticated/schedule/$scheduleId'
import { Route as AuthenticatedOrganizationIntegrationImport } from './routes/_authenticated/organization/integration'
import { Route as AuthenticatedOrganizationEditImport } from './routes/_authenticated/organization/edit'
import { Route as AuthenticatedOrganizationBillingImport } from './routes/_authenticated/organization/billing'
import { Route as AuthenticatedMeFeedbackImport } from './routes/_authenticated/me/feedback'
import { Route as AuthenticatedUserEditSecurityImport } from './routes/_authenticated/user/edit.security'
import { Route as AuthenticatedUserEditAccountImport } from './routes/_authenticated/user/edit.account'
import { Route as AuthenticatedScheduleScheduleIdEditImport } from './routes/_authenticated/schedule/$scheduleId.edit'
import { Route as AuthenticatedScheduleScheduleIdDetailsImport } from './routes/_authenticated/schedule/$scheduleId.details'
import { Route as AuthenticatedScheduleScheduleIdAutomationsImport } from './routes/_authenticated/schedule/$scheduleId.automations'
import { Route as AuthenticatedScheduleScheduleIdAnalyticsImport } from './routes/_authenticated/schedule/$scheduleId.analytics'

// Create/Update Routes

const InvitationRoute = InvitationImport.update({
  id: '/invitation',
  path: '/invitation',
  getParentRoute: () => rootRoute,
} as any)

const PublicRoute = PublicImport.update({
  id: '/_public',
  getParentRoute: () => rootRoute,
} as any)

const AuthenticatedRoute = AuthenticatedImport.update({
  id: '/_authenticated',
  getParentRoute: () => rootRoute,
} as any)

const IndexRoute = IndexImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRoute,
} as any)

const PublicVerifyRoute = PublicVerifyImport.update({
  id: '/verify',
  path: '/verify',
  getParentRoute: () => PublicRoute,
} as any)

const PublicSignupRoute = PublicSignupImport.update({
  id: '/signup',
  path: '/signup',
  getParentRoute: () => PublicRoute,
} as any)

const PublicResetPasswordRoute = PublicResetPasswordImport.update({
  id: '/reset-password',
  path: '/reset-password',
  getParentRoute: () => PublicRoute,
} as any)

const PublicLoginRoute = PublicLoginImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => PublicRoute,
} as any)

const AuthenticatedLogoutRoute = AuthenticatedLogoutImport.update({
  id: '/logout',
  path: '/logout',
  getParentRoute: () => AuthenticatedRoute,
} as any)

const AuthenticatedScheduleIndexRoute = AuthenticatedScheduleIndexImport.update(
  {
    id: '/schedule/',
    path: '/schedule/',
    getParentRoute: () => AuthenticatedRoute,
  } as any,
)

const AuthenticatedMemberIndexRoute = AuthenticatedMemberIndexImport.update({
  id: '/member/',
  path: '/member/',
  getParentRoute: () => AuthenticatedRoute,
} as any)

const AuthenticatedMeIndexRoute = AuthenticatedMeIndexImport.update({
  id: '/me/',
  path: '/me/',
  getParentRoute: () => AuthenticatedRoute,
} as any)

const AuthenticatedDashboardIndexRoute =
  AuthenticatedDashboardIndexImport.update({
    id: '/dashboard/',
    path: '/dashboard/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)

const PublicOrganizationNewRoute = PublicOrganizationNewImport.update({
  id: '/organization/new',
  path: '/organization/new',
  getParentRoute: () => PublicRoute,
} as any)

const PublicOrganizationJoinRoute = PublicOrganizationJoinImport.update({
  id: '/organization/join',
  path: '/organization/join',
  getParentRoute: () => PublicRoute,
} as any)

const PublicAuthGoogleRoute = PublicAuthGoogleImport.update({
  id: '/auth/google',
  path: '/auth/google',
  getParentRoute: () => PublicRoute,
} as any)

const AuthenticatedUserEditRoute = AuthenticatedUserEditImport.update({
  id: '/user/edit',
  path: '/user/edit',
  getParentRoute: () => AuthenticatedRoute,
} as any)

const AuthenticatedScheduleCreateRoute =
  AuthenticatedScheduleCreateImport.update({
    id: '/schedule/create',
    path: '/schedule/create',
    getParentRoute: () => AuthenticatedRoute,
  } as any)

const AuthenticatedScheduleScheduleIdRoute =
  AuthenticatedScheduleScheduleIdImport.update({
    id: '/schedule/$scheduleId',
    path: '/schedule/$scheduleId',
    getParentRoute: () => AuthenticatedRoute,
  } as any)

const AuthenticatedOrganizationIntegrationRoute =
  AuthenticatedOrganizationIntegrationImport.update({
    id: '/organization/integration',
    path: '/organization/integration',
    getParentRoute: () => AuthenticatedRoute,
  } as any)

const AuthenticatedOrganizationEditRoute =
  AuthenticatedOrganizationEditImport.update({
    id: '/organization/edit',
    path: '/organization/edit',
    getParentRoute: () => AuthenticatedRoute,
  } as any)

const AuthenticatedOrganizationBillingRoute =
  AuthenticatedOrganizationBillingImport.update({
    id: '/organization/billing',
    path: '/organization/billing',
    getParentRoute: () => AuthenticatedRoute,
  } as any)

const AuthenticatedMeFeedbackRoute = AuthenticatedMeFeedbackImport.update({
  id: '/me/feedback',
  path: '/me/feedback',
  getParentRoute: () => AuthenticatedRoute,
} as any)

const AuthenticatedUserEditSecurityRoute =
  AuthenticatedUserEditSecurityImport.update({
    id: '/security',
    path: '/security',
    getParentRoute: () => AuthenticatedUserEditRoute,
  } as any)

const AuthenticatedUserEditAccountRoute =
  AuthenticatedUserEditAccountImport.update({
    id: '/account',
    path: '/account',
    getParentRoute: () => AuthenticatedUserEditRoute,
  } as any)

const AuthenticatedScheduleScheduleIdEditRoute =
  AuthenticatedScheduleScheduleIdEditImport.update({
    id: '/edit',
    path: '/edit',
    getParentRoute: () => AuthenticatedScheduleScheduleIdRoute,
  } as any)

const AuthenticatedScheduleScheduleIdDetailsRoute =
  AuthenticatedScheduleScheduleIdDetailsImport.update({
    id: '/details',
    path: '/details',
    getParentRoute: () => AuthenticatedScheduleScheduleIdRoute,
  } as any)

const AuthenticatedScheduleScheduleIdAutomationsRoute =
  AuthenticatedScheduleScheduleIdAutomationsImport.update({
    id: '/automations',
    path: '/automations',
    getParentRoute: () => AuthenticatedScheduleScheduleIdRoute,
  } as any)

const AuthenticatedScheduleScheduleIdAnalyticsRoute =
  AuthenticatedScheduleScheduleIdAnalyticsImport.update({
    id: '/analytics',
    path: '/analytics',
    getParentRoute: () => AuthenticatedScheduleScheduleIdRoute,
  } as any)

// Populate the FileRoutesByPath interface

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexImport
      parentRoute: typeof rootRoute
    }
    '/_authenticated': {
      id: '/_authenticated'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof AuthenticatedImport
      parentRoute: typeof rootRoute
    }
    '/_public': {
      id: '/_public'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof PublicImport
      parentRoute: typeof rootRoute
    }
    '/invitation': {
      id: '/invitation'
      path: '/invitation'
      fullPath: '/invitation'
      preLoaderRoute: typeof InvitationImport
      parentRoute: typeof rootRoute
    }
    '/_authenticated/logout': {
      id: '/_authenticated/logout'
      path: '/logout'
      fullPath: '/logout'
      preLoaderRoute: typeof AuthenticatedLogoutImport
      parentRoute: typeof AuthenticatedImport
    }
    '/_public/login': {
      id: '/_public/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof PublicLoginImport
      parentRoute: typeof PublicImport
    }
    '/_public/reset-password': {
      id: '/_public/reset-password'
      path: '/reset-password'
      fullPath: '/reset-password'
      preLoaderRoute: typeof PublicResetPasswordImport
      parentRoute: typeof PublicImport
    }
    '/_public/signup': {
      id: '/_public/signup'
      path: '/signup'
      fullPath: '/signup'
      preLoaderRoute: typeof PublicSignupImport
      parentRoute: typeof PublicImport
    }
    '/_public/verify': {
      id: '/_public/verify'
      path: '/verify'
      fullPath: '/verify'
      preLoaderRoute: typeof PublicVerifyImport
      parentRoute: typeof PublicImport
    }
    '/_authenticated/me/feedback': {
      id: '/_authenticated/me/feedback'
      path: '/me/feedback'
      fullPath: '/me/feedback'
      preLoaderRoute: typeof AuthenticatedMeFeedbackImport
      parentRoute: typeof AuthenticatedImport
    }
    '/_authenticated/organization/billing': {
      id: '/_authenticated/organization/billing'
      path: '/organization/billing'
      fullPath: '/organization/billing'
      preLoaderRoute: typeof AuthenticatedOrganizationBillingImport
      parentRoute: typeof AuthenticatedImport
    }
    '/_authenticated/organization/edit': {
      id: '/_authenticated/organization/edit'
      path: '/organization/edit'
      fullPath: '/organization/edit'
      preLoaderRoute: typeof AuthenticatedOrganizationEditImport
      parentRoute: typeof AuthenticatedImport
    }
    '/_authenticated/organization/integration': {
      id: '/_authenticated/organization/integration'
      path: '/organization/integration'
      fullPath: '/organization/integration'
      preLoaderRoute: typeof AuthenticatedOrganizationIntegrationImport
      parentRoute: typeof AuthenticatedImport
    }
    '/_authenticated/schedule/$scheduleId': {
      id: '/_authenticated/schedule/$scheduleId'
      path: '/schedule/$scheduleId'
      fullPath: '/schedule/$scheduleId'
      preLoaderRoute: typeof AuthenticatedScheduleScheduleIdImport
      parentRoute: typeof AuthenticatedImport
    }
    '/_authenticated/schedule/create': {
      id: '/_authenticated/schedule/create'
      path: '/schedule/create'
      fullPath: '/schedule/create'
      preLoaderRoute: typeof AuthenticatedScheduleCreateImport
      parentRoute: typeof AuthenticatedImport
    }
    '/_authenticated/user/edit': {
      id: '/_authenticated/user/edit'
      path: '/user/edit'
      fullPath: '/user/edit'
      preLoaderRoute: typeof AuthenticatedUserEditImport
      parentRoute: typeof AuthenticatedImport
    }
    '/_public/auth/google': {
      id: '/_public/auth/google'
      path: '/auth/google'
      fullPath: '/auth/google'
      preLoaderRoute: typeof PublicAuthGoogleImport
      parentRoute: typeof PublicImport
    }
    '/_public/organization/join': {
      id: '/_public/organization/join'
      path: '/organization/join'
      fullPath: '/organization/join'
      preLoaderRoute: typeof PublicOrganizationJoinImport
      parentRoute: typeof PublicImport
    }
    '/_public/organization/new': {
      id: '/_public/organization/new'
      path: '/organization/new'
      fullPath: '/organization/new'
      preLoaderRoute: typeof PublicOrganizationNewImport
      parentRoute: typeof PublicImport
    }
    '/_authenticated/dashboard/': {
      id: '/_authenticated/dashboard/'
      path: '/dashboard'
      fullPath: '/dashboard'
      preLoaderRoute: typeof AuthenticatedDashboardIndexImport
      parentRoute: typeof AuthenticatedImport
    }
    '/_authenticated/me/': {
      id: '/_authenticated/me/'
      path: '/me'
      fullPath: '/me'
      preLoaderRoute: typeof AuthenticatedMeIndexImport
      parentRoute: typeof AuthenticatedImport
    }
    '/_authenticated/member/': {
      id: '/_authenticated/member/'
      path: '/member'
      fullPath: '/member'
      preLoaderRoute: typeof AuthenticatedMemberIndexImport
      parentRoute: typeof AuthenticatedImport
    }
    '/_authenticated/schedule/': {
      id: '/_authenticated/schedule/'
      path: '/schedule'
      fullPath: '/schedule'
      preLoaderRoute: typeof AuthenticatedScheduleIndexImport
      parentRoute: typeof AuthenticatedImport
    }
    '/_authenticated/schedule/$scheduleId/analytics': {
      id: '/_authenticated/schedule/$scheduleId/analytics'
      path: '/analytics'
      fullPath: '/schedule/$scheduleId/analytics'
      preLoaderRoute: typeof AuthenticatedScheduleScheduleIdAnalyticsImport
      parentRoute: typeof AuthenticatedScheduleScheduleIdImport
    }
    '/_authenticated/schedule/$scheduleId/automations': {
      id: '/_authenticated/schedule/$scheduleId/automations'
      path: '/automations'
      fullPath: '/schedule/$scheduleId/automations'
      preLoaderRoute: typeof AuthenticatedScheduleScheduleIdAutomationsImport
      parentRoute: typeof AuthenticatedScheduleScheduleIdImport
    }
    '/_authenticated/schedule/$scheduleId/details': {
      id: '/_authenticated/schedule/$scheduleId/details'
      path: '/details'
      fullPath: '/schedule/$scheduleId/details'
      preLoaderRoute: typeof AuthenticatedScheduleScheduleIdDetailsImport
      parentRoute: typeof AuthenticatedScheduleScheduleIdImport
    }
    '/_authenticated/schedule/$scheduleId/edit': {
      id: '/_authenticated/schedule/$scheduleId/edit'
      path: '/edit'
      fullPath: '/schedule/$scheduleId/edit'
      preLoaderRoute: typeof AuthenticatedScheduleScheduleIdEditImport
      parentRoute: typeof AuthenticatedScheduleScheduleIdImport
    }
    '/_authenticated/user/edit/account': {
      id: '/_authenticated/user/edit/account'
      path: '/account'
      fullPath: '/user/edit/account'
      preLoaderRoute: typeof AuthenticatedUserEditAccountImport
      parentRoute: typeof AuthenticatedUserEditImport
    }
    '/_authenticated/user/edit/security': {
      id: '/_authenticated/user/edit/security'
      path: '/security'
      fullPath: '/user/edit/security'
      preLoaderRoute: typeof AuthenticatedUserEditSecurityImport
      parentRoute: typeof AuthenticatedUserEditImport
    }
  }
}

// Create and export the route tree

interface AuthenticatedScheduleScheduleIdRouteChildren {
  AuthenticatedScheduleScheduleIdAnalyticsRoute: typeof AuthenticatedScheduleScheduleIdAnalyticsRoute
  AuthenticatedScheduleScheduleIdAutomationsRoute: typeof AuthenticatedScheduleScheduleIdAutomationsRoute
  AuthenticatedScheduleScheduleIdDetailsRoute: typeof AuthenticatedScheduleScheduleIdDetailsRoute
  AuthenticatedScheduleScheduleIdEditRoute: typeof AuthenticatedScheduleScheduleIdEditRoute
}

const AuthenticatedScheduleScheduleIdRouteChildren: AuthenticatedScheduleScheduleIdRouteChildren =
  {
    AuthenticatedScheduleScheduleIdAnalyticsRoute:
      AuthenticatedScheduleScheduleIdAnalyticsRoute,
    AuthenticatedScheduleScheduleIdAutomationsRoute:
      AuthenticatedScheduleScheduleIdAutomationsRoute,
    AuthenticatedScheduleScheduleIdDetailsRoute:
      AuthenticatedScheduleScheduleIdDetailsRoute,
    AuthenticatedScheduleScheduleIdEditRoute:
      AuthenticatedScheduleScheduleIdEditRoute,
  }

const AuthenticatedScheduleScheduleIdRouteWithChildren =
  AuthenticatedScheduleScheduleIdRoute._addFileChildren(
    AuthenticatedScheduleScheduleIdRouteChildren,
  )

interface AuthenticatedUserEditRouteChildren {
  AuthenticatedUserEditAccountRoute: typeof AuthenticatedUserEditAccountRoute
  AuthenticatedUserEditSecurityRoute: typeof AuthenticatedUserEditSecurityRoute
}

const AuthenticatedUserEditRouteChildren: AuthenticatedUserEditRouteChildren = {
  AuthenticatedUserEditAccountRoute: AuthenticatedUserEditAccountRoute,
  AuthenticatedUserEditSecurityRoute: AuthenticatedUserEditSecurityRoute,
}

const AuthenticatedUserEditRouteWithChildren =
  AuthenticatedUserEditRoute._addFileChildren(
    AuthenticatedUserEditRouteChildren,
  )

interface AuthenticatedRouteChildren {
  AuthenticatedLogoutRoute: typeof AuthenticatedLogoutRoute
  AuthenticatedMeFeedbackRoute: typeof AuthenticatedMeFeedbackRoute
  AuthenticatedOrganizationBillingRoute: typeof AuthenticatedOrganizationBillingRoute
  AuthenticatedOrganizationEditRoute: typeof AuthenticatedOrganizationEditRoute
  AuthenticatedOrganizationIntegrationRoute: typeof AuthenticatedOrganizationIntegrationRoute
  AuthenticatedScheduleScheduleIdRoute: typeof AuthenticatedScheduleScheduleIdRouteWithChildren
  AuthenticatedScheduleCreateRoute: typeof AuthenticatedScheduleCreateRoute
  AuthenticatedUserEditRoute: typeof AuthenticatedUserEditRouteWithChildren
  AuthenticatedDashboardIndexRoute: typeof AuthenticatedDashboardIndexRoute
  AuthenticatedMeIndexRoute: typeof AuthenticatedMeIndexRoute
  AuthenticatedMemberIndexRoute: typeof AuthenticatedMemberIndexRoute
  AuthenticatedScheduleIndexRoute: typeof AuthenticatedScheduleIndexRoute
}

const AuthenticatedRouteChildren: AuthenticatedRouteChildren = {
  AuthenticatedLogoutRoute: AuthenticatedLogoutRoute,
  AuthenticatedMeFeedbackRoute: AuthenticatedMeFeedbackRoute,
  AuthenticatedOrganizationBillingRoute: AuthenticatedOrganizationBillingRoute,
  AuthenticatedOrganizationEditRoute: AuthenticatedOrganizationEditRoute,
  AuthenticatedOrganizationIntegrationRoute:
    AuthenticatedOrganizationIntegrationRoute,
  AuthenticatedScheduleScheduleIdRoute:
    AuthenticatedScheduleScheduleIdRouteWithChildren,
  AuthenticatedScheduleCreateRoute: AuthenticatedScheduleCreateRoute,
  AuthenticatedUserEditRoute: AuthenticatedUserEditRouteWithChildren,
  AuthenticatedDashboardIndexRoute: AuthenticatedDashboardIndexRoute,
  AuthenticatedMeIndexRoute: AuthenticatedMeIndexRoute,
  AuthenticatedMemberIndexRoute: AuthenticatedMemberIndexRoute,
  AuthenticatedScheduleIndexRoute: AuthenticatedScheduleIndexRoute,
}

const AuthenticatedRouteWithChildren = AuthenticatedRoute._addFileChildren(
  AuthenticatedRouteChildren,
)

interface PublicRouteChildren {
  PublicLoginRoute: typeof PublicLoginRoute
  PublicResetPasswordRoute: typeof PublicResetPasswordRoute
  PublicSignupRoute: typeof PublicSignupRoute
  PublicVerifyRoute: typeof PublicVerifyRoute
  PublicAuthGoogleRoute: typeof PublicAuthGoogleRoute
  PublicOrganizationJoinRoute: typeof PublicOrganizationJoinRoute
  PublicOrganizationNewRoute: typeof PublicOrganizationNewRoute
}

const PublicRouteChildren: PublicRouteChildren = {
  PublicLoginRoute: PublicLoginRoute,
  PublicResetPasswordRoute: PublicResetPasswordRoute,
  PublicSignupRoute: PublicSignupRoute,
  PublicVerifyRoute: PublicVerifyRoute,
  PublicAuthGoogleRoute: PublicAuthGoogleRoute,
  PublicOrganizationJoinRoute: PublicOrganizationJoinRoute,
  PublicOrganizationNewRoute: PublicOrganizationNewRoute,
}

const PublicRouteWithChildren =
  PublicRoute._addFileChildren(PublicRouteChildren)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '': typeof PublicRouteWithChildren
  '/invitation': typeof InvitationRoute
  '/logout': typeof AuthenticatedLogoutRoute
  '/login': typeof PublicLoginRoute
  '/reset-password': typeof PublicResetPasswordRoute
  '/signup': typeof PublicSignupRoute
  '/verify': typeof PublicVerifyRoute
  '/me/feedback': typeof AuthenticatedMeFeedbackRoute
  '/organization/billing': typeof AuthenticatedOrganizationBillingRoute
  '/organization/edit': typeof AuthenticatedOrganizationEditRoute
  '/organization/integration': typeof AuthenticatedOrganizationIntegrationRoute
  '/schedule/$scheduleId': typeof AuthenticatedScheduleScheduleIdRouteWithChildren
  '/schedule/create': typeof AuthenticatedScheduleCreateRoute
  '/user/edit': typeof AuthenticatedUserEditRouteWithChildren
  '/auth/google': typeof PublicAuthGoogleRoute
  '/organization/join': typeof PublicOrganizationJoinRoute
  '/organization/new': typeof PublicOrganizationNewRoute
  '/dashboard': typeof AuthenticatedDashboardIndexRoute
  '/me': typeof AuthenticatedMeIndexRoute
  '/member': typeof AuthenticatedMemberIndexRoute
  '/schedule': typeof AuthenticatedScheduleIndexRoute
  '/schedule/$scheduleId/analytics': typeof AuthenticatedScheduleScheduleIdAnalyticsRoute
  '/schedule/$scheduleId/automations': typeof AuthenticatedScheduleScheduleIdAutomationsRoute
  '/schedule/$scheduleId/details': typeof AuthenticatedScheduleScheduleIdDetailsRoute
  '/schedule/$scheduleId/edit': typeof AuthenticatedScheduleScheduleIdEditRoute
  '/user/edit/account': typeof AuthenticatedUserEditAccountRoute
  '/user/edit/security': typeof AuthenticatedUserEditSecurityRoute
}

export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '': typeof PublicRouteWithChildren
  '/invitation': typeof InvitationRoute
  '/logout': typeof AuthenticatedLogoutRoute
  '/login': typeof PublicLoginRoute
  '/reset-password': typeof PublicResetPasswordRoute
  '/signup': typeof PublicSignupRoute
  '/verify': typeof PublicVerifyRoute
  '/me/feedback': typeof AuthenticatedMeFeedbackRoute
  '/organization/billing': typeof AuthenticatedOrganizationBillingRoute
  '/organization/edit': typeof AuthenticatedOrganizationEditRoute
  '/organization/integration': typeof AuthenticatedOrganizationIntegrationRoute
  '/schedule/$scheduleId': typeof AuthenticatedScheduleScheduleIdRouteWithChildren
  '/schedule/create': typeof AuthenticatedScheduleCreateRoute
  '/user/edit': typeof AuthenticatedUserEditRouteWithChildren
  '/auth/google': typeof PublicAuthGoogleRoute
  '/organization/join': typeof PublicOrganizationJoinRoute
  '/organization/new': typeof PublicOrganizationNewRoute
  '/dashboard': typeof AuthenticatedDashboardIndexRoute
  '/me': typeof AuthenticatedMeIndexRoute
  '/member': typeof AuthenticatedMemberIndexRoute
  '/schedule': typeof AuthenticatedScheduleIndexRoute
  '/schedule/$scheduleId/analytics': typeof AuthenticatedScheduleScheduleIdAnalyticsRoute
  '/schedule/$scheduleId/automations': typeof AuthenticatedScheduleScheduleIdAutomationsRoute
  '/schedule/$scheduleId/details': typeof AuthenticatedScheduleScheduleIdDetailsRoute
  '/schedule/$scheduleId/edit': typeof AuthenticatedScheduleScheduleIdEditRoute
  '/user/edit/account': typeof AuthenticatedUserEditAccountRoute
  '/user/edit/security': typeof AuthenticatedUserEditSecurityRoute
}

export interface FileRoutesById {
  __root__: typeof rootRoute
  '/': typeof IndexRoute
  '/_authenticated': typeof AuthenticatedRouteWithChildren
  '/_public': typeof PublicRouteWithChildren
  '/invitation': typeof InvitationRoute
  '/_authenticated/logout': typeof AuthenticatedLogoutRoute
  '/_public/login': typeof PublicLoginRoute
  '/_public/reset-password': typeof PublicResetPasswordRoute
  '/_public/signup': typeof PublicSignupRoute
  '/_public/verify': typeof PublicVerifyRoute
  '/_authenticated/me/feedback': typeof AuthenticatedMeFeedbackRoute
  '/_authenticated/organization/billing': typeof AuthenticatedOrganizationBillingRoute
  '/_authenticated/organization/edit': typeof AuthenticatedOrganizationEditRoute
  '/_authenticated/organization/integration': typeof AuthenticatedOrganizationIntegrationRoute
  '/_authenticated/schedule/$scheduleId': typeof AuthenticatedScheduleScheduleIdRouteWithChildren
  '/_authenticated/schedule/create': typeof AuthenticatedScheduleCreateRoute
  '/_authenticated/user/edit': typeof AuthenticatedUserEditRouteWithChildren
  '/_public/auth/google': typeof PublicAuthGoogleRoute
  '/_public/organization/join': typeof PublicOrganizationJoinRoute
  '/_public/organization/new': typeof PublicOrganizationNewRoute
  '/_authenticated/dashboard/': typeof AuthenticatedDashboardIndexRoute
  '/_authenticated/me/': typeof AuthenticatedMeIndexRoute
  '/_authenticated/member/': typeof AuthenticatedMemberIndexRoute
  '/_authenticated/schedule/': typeof AuthenticatedScheduleIndexRoute
  '/_authenticated/schedule/$scheduleId/analytics': typeof AuthenticatedScheduleScheduleIdAnalyticsRoute
  '/_authenticated/schedule/$scheduleId/automations': typeof AuthenticatedScheduleScheduleIdAutomationsRoute
  '/_authenticated/schedule/$scheduleId/details': typeof AuthenticatedScheduleScheduleIdDetailsRoute
  '/_authenticated/schedule/$scheduleId/edit': typeof AuthenticatedScheduleScheduleIdEditRoute
  '/_authenticated/user/edit/account': typeof AuthenticatedUserEditAccountRoute
  '/_authenticated/user/edit/security': typeof AuthenticatedUserEditSecurityRoute
}

export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | ''
    | '/invitation'
    | '/logout'
    | '/login'
    | '/reset-password'
    | '/signup'
    | '/verify'
    | '/me/feedback'
    | '/organization/billing'
    | '/organization/edit'
    | '/organization/integration'
    | '/schedule/$scheduleId'
    | '/schedule/create'
    | '/user/edit'
    | '/auth/google'
    | '/organization/join'
    | '/organization/new'
    | '/dashboard'
    | '/me'
    | '/member'
    | '/schedule'
    | '/schedule/$scheduleId/analytics'
    | '/schedule/$scheduleId/automations'
    | '/schedule/$scheduleId/details'
    | '/schedule/$scheduleId/edit'
    | '/user/edit/account'
    | '/user/edit/security'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | ''
    | '/invitation'
    | '/logout'
    | '/login'
    | '/reset-password'
    | '/signup'
    | '/verify'
    | '/me/feedback'
    | '/organization/billing'
    | '/organization/edit'
    | '/organization/integration'
    | '/schedule/$scheduleId'
    | '/schedule/create'
    | '/user/edit'
    | '/auth/google'
    | '/organization/join'
    | '/organization/new'
    | '/dashboard'
    | '/me'
    | '/member'
    | '/schedule'
    | '/schedule/$scheduleId/analytics'
    | '/schedule/$scheduleId/automations'
    | '/schedule/$scheduleId/details'
    | '/schedule/$scheduleId/edit'
    | '/user/edit/account'
    | '/user/edit/security'
  id:
    | '__root__'
    | '/'
    | '/_authenticated'
    | '/_public'
    | '/invitation'
    | '/_authenticated/logout'
    | '/_public/login'
    | '/_public/reset-password'
    | '/_public/signup'
    | '/_public/verify'
    | '/_authenticated/me/feedback'
    | '/_authenticated/organization/billing'
    | '/_authenticated/organization/edit'
    | '/_authenticated/organization/integration'
    | '/_authenticated/schedule/$scheduleId'
    | '/_authenticated/schedule/create'
    | '/_authenticated/user/edit'
    | '/_public/auth/google'
    | '/_public/organization/join'
    | '/_public/organization/new'
    | '/_authenticated/dashboard/'
    | '/_authenticated/me/'
    | '/_authenticated/member/'
    | '/_authenticated/schedule/'
    | '/_authenticated/schedule/$scheduleId/analytics'
    | '/_authenticated/schedule/$scheduleId/automations'
    | '/_authenticated/schedule/$scheduleId/details'
    | '/_authenticated/schedule/$scheduleId/edit'
    | '/_authenticated/user/edit/account'
    | '/_authenticated/user/edit/security'
  fileRoutesById: FileRoutesById
}

export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AuthenticatedRoute: typeof AuthenticatedRouteWithChildren
  PublicRoute: typeof PublicRouteWithChildren
  InvitationRoute: typeof InvitationRoute
}

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AuthenticatedRoute: AuthenticatedRouteWithChildren,
  PublicRoute: PublicRouteWithChildren,
  InvitationRoute: InvitationRoute,
}

export const routeTree = rootRoute
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()

/* ROUTE_MANIFEST_START
{
  "routes": {
    "__root__": {
      "filePath": "__root.tsx",
      "children": [
        "/",
        "/_authenticated",
        "/_public",
        "/invitation"
      ]
    },
    "/": {
      "filePath": "index.tsx"
    },
    "/_authenticated": {
      "filePath": "_authenticated.tsx",
      "children": [
        "/_authenticated/logout",
        "/_authenticated/me/feedback",
        "/_authenticated/organization/billing",
        "/_authenticated/organization/edit",
        "/_authenticated/organization/integration",
        "/_authenticated/schedule/$scheduleId",
        "/_authenticated/schedule/create",
        "/_authenticated/user/edit",
        "/_authenticated/dashboard/",
        "/_authenticated/me/",
        "/_authenticated/member/",
        "/_authenticated/schedule/"
      ]
    },
    "/_public": {
      "filePath": "_public.tsx",
      "children": [
        "/_public/login",
        "/_public/reset-password",
        "/_public/signup",
        "/_public/verify",
        "/_public/auth/google",
        "/_public/organization/join",
        "/_public/organization/new"
      ]
    },
    "/invitation": {
      "filePath": "invitation.tsx"
    },
    "/_authenticated/logout": {
      "filePath": "_authenticated/logout.tsx",
      "parent": "/_authenticated"
    },
    "/_public/login": {
      "filePath": "_public/login.tsx",
      "parent": "/_public"
    },
    "/_public/reset-password": {
      "filePath": "_public/reset-password.tsx",
      "parent": "/_public"
    },
    "/_public/signup": {
      "filePath": "_public/signup.tsx",
      "parent": "/_public"
    },
    "/_public/verify": {
      "filePath": "_public/verify.tsx",
      "parent": "/_public"
    },
    "/_authenticated/me/feedback": {
      "filePath": "_authenticated/me/feedback.tsx",
      "parent": "/_authenticated"
    },
    "/_authenticated/organization/billing": {
      "filePath": "_authenticated/organization/billing.tsx",
      "parent": "/_authenticated"
    },
    "/_authenticated/organization/edit": {
      "filePath": "_authenticated/organization/edit.tsx",
      "parent": "/_authenticated"
    },
    "/_authenticated/organization/integration": {
      "filePath": "_authenticated/organization/integration.tsx",
      "parent": "/_authenticated"
    },
    "/_authenticated/schedule/$scheduleId": {
      "filePath": "_authenticated/schedule/$scheduleId.tsx",
      "parent": "/_authenticated",
      "children": [
        "/_authenticated/schedule/$scheduleId/analytics",
        "/_authenticated/schedule/$scheduleId/automations",
        "/_authenticated/schedule/$scheduleId/details",
        "/_authenticated/schedule/$scheduleId/edit"
      ]
    },
    "/_authenticated/schedule/create": {
      "filePath": "_authenticated/schedule/create.tsx",
      "parent": "/_authenticated"
    },
    "/_authenticated/user/edit": {
      "filePath": "_authenticated/user/edit.tsx",
      "parent": "/_authenticated",
      "children": [
        "/_authenticated/user/edit/account",
        "/_authenticated/user/edit/security"
      ]
    },
    "/_public/auth/google": {
      "filePath": "_public/auth.google.tsx",
      "parent": "/_public"
    },
    "/_public/organization/join": {
      "filePath": "_public/organization/join.tsx",
      "parent": "/_public"
    },
    "/_public/organization/new": {
      "filePath": "_public/organization/new.tsx",
      "parent": "/_public"
    },
    "/_authenticated/dashboard/": {
      "filePath": "_authenticated/dashboard/index.tsx",
      "parent": "/_authenticated"
    },
    "/_authenticated/me/": {
      "filePath": "_authenticated/me/index.tsx",
      "parent": "/_authenticated"
    },
    "/_authenticated/member/": {
      "filePath": "_authenticated/member/index.tsx",
      "parent": "/_authenticated"
    },
    "/_authenticated/schedule/": {
      "filePath": "_authenticated/schedule/index.tsx",
      "parent": "/_authenticated"
    },
    "/_authenticated/schedule/$scheduleId/analytics": {
      "filePath": "_authenticated/schedule/$scheduleId.analytics.tsx",
      "parent": "/_authenticated/schedule/$scheduleId"
    },
    "/_authenticated/schedule/$scheduleId/automations": {
      "filePath": "_authenticated/schedule/$scheduleId.automations.tsx",
      "parent": "/_authenticated/schedule/$scheduleId"
    },
    "/_authenticated/schedule/$scheduleId/details": {
      "filePath": "_authenticated/schedule/$scheduleId.details.tsx",
      "parent": "/_authenticated/schedule/$scheduleId"
    },
    "/_authenticated/schedule/$scheduleId/edit": {
      "filePath": "_authenticated/schedule/$scheduleId.edit.tsx",
      "parent": "/_authenticated/schedule/$scheduleId"
    },
    "/_authenticated/user/edit/account": {
      "filePath": "_authenticated/user/edit.account.tsx",
      "parent": "/_authenticated/user/edit"
    },
    "/_authenticated/user/edit/security": {
      "filePath": "_authenticated/user/edit.security.tsx",
      "parent": "/_authenticated/user/edit"
    }
  }
}
ROUTE_MANIFEST_END */
